import { PositionStaticImageProps, PositionStaticImagesProps } from '@sections/rachel-zoe/components/PositionedStaticImages';

export const SECTION_ID = 'Rachel_Zoe_Wedding_Suite';
export const AUTO_PLAY_INTERVAL = 3000;
export const PLAY_SPEED = 500;
export const EASING = 'easeSinInOut';

export const keyImage: PositionStaticImageProps = {
  url: 'rachel zoe/themes/rz.jpg',
  belowSm: {
    width: 158,
    height: 136,
  },
  sm: {
    width: 420,
    height: 363,
  },
};

export const groupImages: PositionStaticImagesProps[] = [
  [
    {
      url: 'rachel zoe/themes/1/daisy_rz_brannan.jpg',
      belowSm: {
        width: 202,
        height: 126,
        top: 160,
        right: 102,
        show: true,
      },
      sm: {
        width: 541,
        height: 338,
        top: 150,
        right: 350,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/1/garden_black_rz_inv.jpg',
      belowSm: {
        width: 84,
        height: 115,
        top: 80,
        left: 111,
        show: true,
      },
      sm: {
        width: 224,
        height: 307,
        top: 80,
        left: 400,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/1/falling_petals_rz_std.jpg',
      belowSm: {
        width: 96,
        height: 129,
        top: 270,
        left: 100,
        show: true,
      },
      sm: {
        width: 257,
        height: 352,
        top: 465,
        left: 410,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/1/spring_garden_ivory_rz_inv.jpg',
      belowSm: {
        width: 84,
        height: 115,
        top: 320,
        right: 100,
        show: true,
      },
      sm: {
        width: 180,
        height: 246,
        top: 890,
        left: 540,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/1/floating_feather_rz_aloha.jpg',
      belowSm: {
        width: 203,
        height: 127,
        top: -180,
        right: 30,
        show: true,
      },
      sm: {
        width: 542,
        height: 339,
        top: 1044,
        left: -190,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/1/snake_ivory_rz_inv.jpg',
      belowSm: {
        width: 121,
        height: 165,
        top: 200,
        right: -60,
        show: true,
      },
      sm: {
        width: 323,
        height: 442,
        top: 840,
        right: 400,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/1/winter_flower_rz_inv.jpg',
      belowSm: {
        width: 96,
        height: 128,
        top: -20,
        right: 120,
        show: true,
      },
      sm: {
        width: 186,
        height: 250,
        top: 540,
        right: 430,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/1/cactus_flower_cream_rz_aloha.jpg',
      belowSm: {
        width: 203,
        height: 127,
        top: -160,
        left: 30,
        show: true,
      },
      sm: {
        width: 0,
        height: 0,
        show: false,
      },
    },
  ],
  [
    {
      url: 'rachel zoe/themes/2/palm_leaves_rz_aloha.jpg',
      belowSm: {
        width: 1,
        height: 1,
        show: false,
      },
      sm: {
        width: 541,
        height: 338,
        top: 150,
        right: 350,
        zIndex: 4,
        show: true,
      },
    },
    {
      url: 'rachel zoe/themes/2/winter_flower_rz_aloha.jpg',
      belowSm: {
        width: 202,
        height: 126,
        top: 160,
        right: 102,
        show: true,
      },
      sm: {
        width: 1,
        height: 1,
        show: false,
      },
    },
    {
      url: 'rachel zoe/themes/2/spring_garden_black_rz_inv.jpg',
      belowSm: {
        width: 84,
        height: 115,
        top: 80,
        left: 111,
        show: true,
      },
      sm: {
        width: 224,
        height: 307,
        top: 80,
        left: 400,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/2/cactus_flower_cream_rz_std.jpg',
      belowSm: {
        width: 96,
        height: 129,
        top: 270,
        left: 100,
        show: true,
      },
      sm: {
        width: 257,
        height: 352,
        top: 465,
        left: 410,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/2/snake_black_rz_inv.jpg',
      belowSm: {
        width: 84,
        height: 115,
        top: 320,
        right: 100,
        show: true,
      },
      sm: {
        width: 180,
        height: 246,
        top: 890,
        left: 540,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/2/falling_petals_rz_brannan.jpg',
      belowSm: {
        width: 203,
        height: 127,
        top: -160,
        left: 30,
        show: true,
      },
      sm: {
        width: 542,
        height: 339,
        top: 1044,
        left: -190,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/2/leuchadendron_rz_inv.jpg',
      belowSm: {
        width: 121,
        height: 165,
        top: 200,
        right: -60,
        show: true,
      },
      sm: {
        width: 323,
        height: 442,
        top: 840,
        right: 400,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/2/monet_flower_rz_inv.jpg',
      belowSm: {
        width: 96,
        height: 128,
        top: -20,
        right: 120,
        show: true,
      },
      sm: {
        width: 186,
        height: 250,
        top: 540,
        right: 430,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/2/palm_leaves_rz_aloha.jpg',
      belowSm: {
        width: 203,
        height: 127,
        top: -180,
        right: 30,
        show: true,
      },
      sm: {
        width: 0,
        height: 0,
        show: false,
      },
    },
  ],
  [
    {
      url: 'rachel zoe/themes/3/snake_ivory_rz_aloha.jpg',
      belowSm: {
        width: 202,
        height: 126,
        top: 160,
        right: 102,
        show: true,
      },
      sm: {
        width: 541,
        height: 338,
        top: 150,
        right: 350,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/3/floating_feather_rz_std.jpg',
      belowSm: {
        width: 84,
        height: 115,
        top: 80,
        left: 111,
        show: true,
      },
      sm: {
        width: 224,
        height: 307,
        top: 80,
        left: 400,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/3/palm_leaves_rz_std.jpg',
      belowSm: {
        width: 96,
        height: 129,
        top: 270,
        left: 100,
        show: true,
      },
      sm: {
        width: 257,
        height: 352,
        top: 465,
        left: 410,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/3/cactus_flower_black_rz_inv.jpg',
      belowSm: {
        width: 84,
        height: 115,
        top: 320,
        right: 100,
        show: true,
      },
      sm: {
        width: 180,
        height: 246,
        top: 890,
        left: 540,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/3/leuchadendron_rz_brannan.jpg',
      belowSm: {
        width: 203,
        height: 127,
        top: -180,
        right: 30,
        show: true,
      },
      sm: {
        width: 542,
        height: 339,
        top: 1044,
        left: -190,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/3/daisy_rz_inv.jpg',
      belowSm: {
        width: 121,
        height: 165,
        top: 200,
        right: -60,
        show: true,
      },
      sm: {
        width: 323,
        height: 442,
        top: 840,
        right: 400,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/3/winter_flower_rz_std.jpg',
      belowSm: {
        width: 96,
        height: 128,
        top: -20,
        right: 120,
        show: true,
      },
      sm: {
        width: 186,
        height: 250,
        top: 540,
        right: 430,
        zIndex: 4,
      },
    },
    {
      url: 'rachel zoe/themes/3/cactus_flower_black_rz_brannan.jpg',
      belowSm: {
        width: 203,
        height: 127,
        top: -160,
        left: 30,
        show: true,
      },
      sm: {
        width: 0,
        height: 0,
        show: false,
      },
    },
  ],
];
